import * as React from "react";
import { Dropdown } from "react-bootstrap";
import FaIcon from "../fa-icon/fa-icon";
import IconEnum from "../../enums/icon.enum";
import { SingleSelectProps } from "./single-select.props";
import "./single-select.scss";

const SingleSelect = (props: SingleSelectProps) => {
  const { selected, options, onSelect, mpngStyle } = props;
  const [down, setDown] = React.useState(true);

  const renderDropdownIcon = () => {
    if (down) {
      return <FaIcon className="single-select-icon" icon={IconEnum.CHEVRON_DOWN} />;
    } else {
      return <FaIcon className="single-select-icon" icon={IconEnum.CHEVRON_UP} />;
    }
  };

  return (
    <Dropdown
      role="menu"
      className={`single-select ${mpngStyle ? "mpng-style" : ""}`}
      onSelect={onSelect}
      onToggle={() => setDown(!down)}
    >
      <Dropdown.Toggle className="single-select-toggle" data-testid="single-select-toggle">
        {selected}
        {renderDropdownIcon()}
      </Dropdown.Toggle>
      <Dropdown.Menu className="single-select-menu">
        {options.map((item: string) => {
          return (
            <Dropdown.Item key={item} className="single-select-item" active={item === selected} eventKey={item}>
              {item}
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default SingleSelect;
